<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.assignBranch.retailOutlets") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/placeholder (1).svg" width="80%" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ branchCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.assignBranch.title") }}
                </h3>
              </div>
              <div class="col-md-6 text-right section___column_2">
                <div class="row align-items-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="220"
                  field="name"
                  :headerText="$t('text.assignBranch.retailOutletName')"
                ></e-column>
                <e-column
                  width="200"
                  field="city"
                  :headerText="$t('text.assignBranch.city')"
                ></e-column>
                <e-column
                  width="200"
                  field="state"
                  :headerText="$t('text.assignBranch.state')"
                ></e-column>
                <e-column
                  width="200"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <!-- <EditZoneModal :id="zoneId" :zoneName="zoneName"></EditZoneModal> -->
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Assign Branch :: Epump Portal",
  name: "AssignBranches",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      branchCount: "",
      unassignedBranches: "",
      company: null,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div> 
                <button class="mailRecipient_btn assign_branch" v-on:click="assignBranch(data.id)">{{data.assignOutletButton}}</button> 
                </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              assignBranch(branchId) {
                this.$eventHub.$emit("assignBranch", branchId);
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getBranches();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if(this.$route.query.companyId){
      this.getBranches();
    }
    this.$eventHub.$on("assignBranch", (branchId) => {
      this.assignBranch(branchId);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("assignBranch");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    assignBranch(branchId) {
      const data = {
        zoneId: this.$route.query.id,
        branchId,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Zones/AssignBranch`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message:
              response.status === 200
                ? this.$t("text.assignBranch.successfullyAssigned")
                : response.data.message,
            type: "success",
            duration: 2000,
          });
          this.reassign(branchId);
        })
        .catch((error) => {
          $(".loader").hide();
        });
    },
    getBranches() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Zones/CompanyBranchesNotMapped/${this.$route.query.companyId ? this.$route.query.companyId : this.company.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.forEach((zone, index) => {
            zone.index = index + 1;
            zone.assignOutletButton = this.$t("text.assignBranch.assignOutlet");
          });
          this.showLoader = false;
          this.unassignedBranches = response.data;
          this.branchCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    reassign(branchId) {
      let newData = this.unassignedBranches;
      newData = newData.filter((cur) => cur.id != branchId);
      newData.sort((a, b) => {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      newData.forEach((zone, index) => {
        zone.index = index + 1;
      });
      this.branchCount = newData.length;
      this.unassignedBranches = newData;
      this.$refs.dataGrid.ej2Instances.setProperties({ dataSource: newData });
      this.refreshGrid();
    },
  },
};
</script>
